import React, {Component} from 'react';
import {createHistory} from '../history';
import LoginStore from '../stores/LoginStore';

export default function withAuth(AuthComponent) {

    return class AuthWrapped extends Component {
        constructor() {
            super();
            this.state = this._getLoginState();
        }

        _getLoginState() {
            return {
                userLoggedIn: LoginStore.isLoggedIn(),
                user: LoginStore.getUser()
            };
        }

        componentDidMount() {
            if(!LoginStore.isLoggedIn()){
                // LoginStore.logout();
                // createHistory.push('/login');
            }
            else {
                try {
                    this.setState(this._getLoginState());
                }
                catch(err){
                    // LoginStore.logout();
                    // createHistory.push('/login');
                }
            }
            LoginStore.addChangeListener(this._onChange.bind(this));
        }

        // componentWillMount() {
        //     if(!LoginStore.isLoggedIn()){
        //         LoginStore.logout();
        //         createHistory.push('/login');
        //     }
        //     else {
        //         try {
        //             this.setState(this._getLoginState());
        //         }
        //         catch(err){
        //             LoginStore.logout();
        //             createHistory.push('/login');
        //         }
        //     }
        // }

        componentWillUnmount() {
            LoginStore.removeChangeListener(this._onChange.bind(this));
        }

        render() {
                return (
                    <AuthComponent {...this.props} history={createHistory} user={this.state.user}
                                   userLoggedIn={this.state.userLoggedIn} />
                )
        }

        _onChange() {
            this.setState(this._getLoginState());
        }

    }
}